import React from 'react';
import './App.css';
import WeatherCard  from './WeatherCard';
function App() {
  return (
    <div className="App">
     <WeatherCard />
    </div>
  );
}

export default App;
